import React from 'react';

import styles from './Toggle.module.scss';

export default function Toggle({ label, isChecked = false, onChecked }) {
    const checked = !!isChecked;

    return (
        <div className={styles['toggle-container']}>
            <label className={styles['toggle-container__content']} aria-labelledby={label}>
                <input
                    type="checkbox"
                    className={styles['input']}
                    checked={checked}
                    onChange={(e) => onChecked?.(e.target.checked)}
                />
                <span className={styles['slider']}></span>
            </label>
        </div>
    );
}